export default {
	title: 'Cylinder Config',
	actions: {
		add: 'Add',
		edit: 'Edit',
		delete: 'Delete',
		batchDelete: 'Batch Delete',
		save: 'Save',
		cancel: 'Cancel',
		confirm: 'Confirm'
	},
	messages: {
		deleteSuccess: 'Delete successful',
		actionSuccess: 'Operation successful',
		requiredError: 'Required field cannot be empty'
	},
	buttons: {
		add: 'Add',
		batchDelete: 'Batch Delete',
		edit: 'Edit',
		delete: 'Delete'
	},
	table: {
		phaseAngle: 'Phase Angle',
		cylinderNumber: 'Cylinder Number',
		cylinderName: 'Cylinder Name',
		diagnosisNumber: 'Diagnosis Number',
		deviceNumber: 'Device Number',
		linkMass: 'Link Mass (kg)',
		intakePressure: 'Intake Pressure (kPa)',
		outletPressure: 'Outlet Pressure (kPa)',
		crankRadius: 'Crank Radius',
		inertiaMass: 'Inertia Mass (kg)',
		cylinderBoreDiameter: 'Cylinder Bore Diameter',
		pistonRodDiameter: 'Piston Rod Diameter',
		linkLength: 'Link Length (m)',
		pistonArea: 'Piston Area',
		poleArea: 'Pole Area',
		action: 'Action'
	},
	form: {
		placeholder: {
			projNo: 'Diagnosis Number',
			deviceNo: 'Device Number',
			phaseAngle: 'Please enter',
			number: 'Please enter',
			linkMass: 'Please enter link mass',
			intakePressure: 'Please enter intake pressure',
			outletPressure: 'Please enter outlet pressure',
			crankRadius: 'Please enter crank radius',
			inertiaMass: 'Please enter inertia mass',
			cylinderBoreDiameter: 'Please enter cylinder bore diameter',
			pistonRodDiameter: 'Please enter piston rod diameter',
			linkLength: 'Please enter link length',
			pistonArea: 'Please enter piston area',
			poleArea: 'Please enter pole area'
		},
		label: {
			phaseAngle: 'Phase Angle',
			number: 'Cylinder Number',
			projNo: 'Diagnosis Number',
			deviceNo: 'Device Number',
			linkMass: 'Link Mass (kg)',
			intakePressure: 'Intake Pressure (kPa)',
			outletPressure: 'Outlet Pressure (kPa)',
			crankRadius: 'Crank Radius',
			inertiaMass: 'Inertia Mass (kg)',
			cylinderBoreDiameter: 'Cylinder Bore Diameter',
			pistonRodDiameter: 'Piston Rod Diameter',
			linkLength: 'Link Length (m)',
			pistonArea: 'Piston Area',
			poleArea: 'Pole Area'
		}
	},
	config: {
		gridLayout: 'Grid Layout'
	},
	dialog: {
		add: 'Add',
		update: 'Edit'
	}
}
